import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'faucet',
  size: 24,
  node: [
    ['path', { d: 'M10.083 5.428 5.57 4.083a2 2 0 10.001 3.834l4.512-1.345', key: '1curt5' }],
    ['path', { d: 'M12 8v3', key: 'hwp4zt' }],
    ['path', { d: 'm13.917 5.428 4.511-1.345a2 2 0 110 3.834l-4.51-1.345', key: '1j1ygv' }],
    ['path', { d: 'M18 17v-4.006', key: '1ovurp' }],
    ['path', { d: 'M22 11v8', key: '15un1y' }],
    [
      'path',
      {
        d: 'M22 12h-3a1 1 0 00-1 .994h-2.539a4 4 0 00-6.915-.012L7 13a5 5 0 00-5 5v1a1 1 0 001 1h2a1 1 0 001-1v-1a1 1 0 01.995-1l1.552.018a4 4 0 006.907 0L18 17a1 1 0 001 1h3',
        key: '2dw4iy',
      },
    ],
    ['circle', { cx: '12', cy: '6', r: '2', key: '1jj5th' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Faucet
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMDgzIDUuNDI4IDUuNTcgNC4wODNhMiAyIDAgMTAuMDAxIDMuODM0bDQuNTEyLTEuMzQ1IiAvPgogIDxwYXRoIGQ9Ik0xMiA4djMiIC8+CiAgPHBhdGggZD0ibTEzLjkxNyA1LjQyOCA0LjUxMS0xLjM0NWEyIDIgMCAxMTAgMy44MzRsLTQuNTEtMS4zNDUiIC8+CiAgPHBhdGggZD0iTTE4IDE3di00LjAwNiIgLz4KICA8cGF0aCBkPSJNMjIgMTF2OCIgLz4KICA8cGF0aCBkPSJNMjIgMTJoLTNhMSAxIDAgMDAtMSAuOTk0aC0yLjUzOWE0IDQgMCAwMC02LjkxNS0uMDEyTDcgMTNhNSA1IDAgMDAtNSA1djFhMSAxIDAgMDAxIDFoMmExIDEgMCAwMDEtMXYtMWExIDEgMCAwMS45OTUtMWwxLjU1Mi4wMThhNCA0IDAgMDA2LjkwNyAwTDE4IDE3YTEgMSAwIDAwMSAxaDMiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSI2IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/faucet
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Faucet = createLucideIcon(__iconData);

export default Faucet;
